export default __webpack_public_path__ + "static/media/IMAGE_1.67ecd8b5.png";